// components/YoutubeVideo.js
import React from "react";
import YouTube from "react-youtube-embed";

const YoutubeVideo = () => {
  return (
    <YouTube id="https://www.youtube.com/embed/V7eiv3E0jUM?autoplay=1&mute=1" />
  );
};

export default YoutubeVideo;
